import { httpGetAndParse } from '../../../utils/fetchService';

export const fetchPartnershipFlowThroughAmounts = ({ taxYear, period, entityId }) =>
  httpGetAndParse({
    route: `/api/entities/partnership-flow-through-amounts/${taxYear}/${period}/${entityId}`,
    errorMessage: 'Fetching partnership flow-through amounts failed',
  });
